import React from "react";
import { toast } from "react-toastify";

const alertStyle = (callbackFn: any) => ({
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  onClose: () => (callbackFn ? callbackFn() : null),
});


export const SuccessToast = (message: string, callBackHandler = null) => {
  const style: any = alertStyle(callBackHandler);
  toast.success(message, style);
};

export const ErrorToast = (message: string, callBackHandler = null) => {
  const style: any = alertStyle(callBackHandler);
  toast.error(message, style);
};

export const WarningToast = (message: string, callBackHandler = null) => {
  const style: any = alertStyle(callBackHandler);
  toast.warn(message, style);
};